/** Μορφοποιήσεις που μοιράζονται πολλές οθόνες. */

const ATHENS = 'Europe/Athens'

/**
 * Ημερομηνία ως «9 Αυγ 2026».
 *
 * Το «9/8/26» διαβάζεται και ως 8 Σεπτεμβρίου: με τον μήνα γραμμένο με
 * γράμματα δεν υπάρχει αμφιβολία, και χωράει το ίδιο.
 */
const DATE = new Intl.DateTimeFormat('el-GR', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: ATHENS,
})

/** Ημερομηνία και ώρα ως «9 Αυγ, 12:46». Το έτος περισσεύει δίπλα στην ώρα. */
const DATE_TIME = new Intl.DateTimeFormat('el-GR', {
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: ATHENS,
})

/** «ΕΕΕΕ-ΜΜ-ΗΗ» στη ζώνη της Αθήνας, για συγκρίσεις ημέρας. */
const DAY_KEY = new Intl.DateTimeFormat('en-CA', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  timeZone: ATHENS,
})

/**
 * Μια σκέτη ημερομηνία («2026-08-09») γίνεται μεσημέρι τοπικής ώρας, ώστε να
 * μην γλιστρήσει στην προηγούμενη μέρα όταν ο browser τρέχει δυτικά της Αθήνας.
 */
function toDate(value: string): Date {
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split('-').map(Number)
    return new Date(year, month - 1, day, 12)
  }
  return new Date(value)
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—'
  return DATE.format(toDate(value))
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—'
  return DATE_TIME.format(toDate(value))
}

export function dayKey(value: string | Date): string {
  return DAY_KEY.format(typeof value === 'string' ? toDate(value) : value)
}

/**
 * «Σήμερα», «Χθες», «Αύριο» ή η ημερομηνία. Ο χρήστης σκέφτεται σε μέρες της
 * εβδομάδας, όχι σε αριθμούς: η παράδοση «αύριο» λέει περισσότερα από «4 Οκτ».
 */
export function formatRelativeDay(
  value: string | null | undefined,
  t: (key: string) => string,
): string {
  if (!value) return '—'
  const key = dayKey(value)
  const now = new Date()
  if (key === dayKey(now)) return t('common.today')
  if (key === dayKey(new Date(now.getTime() - 86_400_000))) return t('common.yesterday')
  if (key === dayKey(new Date(now.getTime() + 86_400_000))) return t('common.tomorrow')
  return formatDate(value)
}
